// extracted by mini-css-extract-plugin
export var standaloneTable = "_ia-0";
export var standaloneTableWithBodyFill = "_ia-1";
export var withExtraHeader = "_ia-2";